import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the hubspotVerify state domain
 */

const selectHubspotVerifyDomain = state => state.hubspotVerify || initialState;

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(
    selectHubspotVerifyDomain,
    subState => subState.isVerify
  );

const makeSelectError = () =>
  createSelector(
    selectHubspotVerifyDomain,
    subState => subState.error
  );

export { makeSelectIsVerify, makeSelectError };
